import NamedRegExp from "named-regexp-groups";
import _isEmpty from 'lodash/isEmpty';

export function abbrNum(number, decPlaces) {
	// https://stackoverflow.com/questions/2685911/is-there-a-way-to-round-numbers-into-a-reader-friendly-format-e-g-1-1k
	decPlaces = Math.pow(10,decPlaces);
	var abbrev = [ "K", "M", "B", "T" ];

	for (var i=abbrev.length-1; i>=0; i--) {
		var size = Math.pow(10,(i+1)*3);
		if(size <= number) {
			number = Math.round(number*decPlaces/size)/decPlaces;
			if((number == 1000) && (i < abbrev.length - 1)) {
				number = 1;
				i++;
			}
			number += abbrev[i];
			break;
		}
	}

	return number;
}

export function thousandSeperator(raw){
	return raw.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g,'$1,');
}

export function getAuthUser(user){
	return new Proxy(user, {
		get(target,prop){
			if(_isEmpty(target)) return target.isAuthorized = "Unauthorized" ;
			if(typeof prop != 'symbol'){
				let matcher = new NamedRegExp("^((?<roles>is_)|(?<permissions>has_))(?<item>.*)$");
				let matches = prop.match(matcher);

				let matchedgroups = [];
				if (matches !== null) {
					matchedgroups = Object.keys(matches.groups)
						.filter(k => k != "0")
						.map((k) => [k, matches.groups[k] !== undefined])
						.filter(([_, ok]) => ok);
				}
				if (matchedgroups.length > 0) {
					let type = matchedgroups[0][0]
					let item = matches.groups.item;
					return target[type].hasOwnProperty(item);
				}
			}
			return target[prop];
		}
	});
}

export function loadImage(url) {
	return new Promise((res, rej) => {
		let img = new Image();
		img.addEventListener('load', e => res(img));
		img.addEventListener('error', () => rej(new Error(`Failed to load image's URL: ${url}`)));
		img.src = url;
	});
}

export function formatKeyword(keyword){
	return keyword.includes("|") ? keyword.split("|").map(key => key.includes("+") ? key.replace("+", " AND ") : key.replace("-", " NOT ")).join("") : keyword;
}

export function loadTopMentionImages(urls=[]){
	return urls.map(url => {
		return new Promise((res, rej) => {
			let img = new Image();
			img.src = url;
			img.crossOrigin = 'Anonymous';
			img.onload = function(){
				res(img);
			}
		})
	})
}

